<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style="  color:white; text-align: center; margin-bottom: 10px">Vocational Section</h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: cover; border-radius: 10px"
      src="assets/img/school/news/10.jpeg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <p style="color: white;">
          Vocational education is the life and work oriented education. That is,
          it is a system of education which is related to life and work and
          applicable in practical life. In other words, it is a technique of
          increasing knowledge, concepts and skills which is taught in
          practically to perform a task efficiently in real life situation. In
          this section, students above 14 years of age are made skilled for work
          through various types of training in various fields. <br />
          The importance of vocational education is widely recognized today.
          Vocational education is not a mechanical education. It is a
          life-oriented education that spans the globe. Many have to drop out
          after primary, junior and secondary education as learning disabilities
          make them impossible to continue academic studies further. <br />
          But they have infinite latent talent. One of the aims of vocational
          education is to play an effective role in the development of social
          and economic lifestyle of special children. <br />
          Currently, total number of students in vocational class is 22. There
          are 2 teachers and 2 teaching assistants to nurture them. <br />
          The vocational section is currently providing the following trades and
          training programmes: <br />
          • Making envelope. <br />
          • Working in the block.<br />
          • Making various types of handicraft products.<br />
          • Making net flower.<br />
          • Making popcorn.<br />
          • Making different types of jewelry goods.<br />
          • Cooking.<br />
          • Learning how to run a grocery shop.<br />
          • Gardening.<br />
          • Mobile servicing.<br />
          • Tailoring.<br />
          • Making cake items in Bakery and so on.<br />

          To teach accounting system, students do canteen work. Students are
          taken on outings once in every week to improve their behavioral and
          social skills. Physiotherapy services and computer education are
          provided in every week as per the needs of the students.<br />
          The students of the Vocational stream have been exhibiting their
          talent by participating in national and annual competitions in sports,
          drawing, dance and singing and many more.<br />
          Apart from this, the students of the vocational section are sent for
          training to various outside institutions to further enhance their
          skills, such as: Underprivileged Children's Educational Programme
          (UCEP), Readymade Garments and so on. Various products made by
          vocational students are displayed and sold in various fairs and
          stalls. The profits from the sale are used for the development of
          special education students. At present, various activities are
          underway to make this section more prosperous and up-to-date.
        </p>
      </div>
    </div>
  </div>
</div>
